import { History, HistoryProps } from '../../history/History';
import { Panel } from '../../panel/Panel';

export const HistoryTabPanel = ({ overrides }: HistoryProps) => {
  return (
    <Panel restrictedWidth>
      <History overrides={overrides} />
    </Panel>
  );
};
